import SelectFilter from "@components/common/SelectFilter.jsx";

function StaticSelectFilter({
	id,
	label,
	placeholder,
	value,
	onChange,
	options,
	optionLabel = "label",
	optionValue = "value",
	disabled = false,
	showSearch = true,
	searchPlaceholder = "Search Filter by",
}) {
	return (
		<SelectFilter
			id={id}
			dataTestId={id}
			label={label}
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			options={options}
			optionLabel={optionLabel}
			optionValue={optionValue}
			showSearch={showSearch}
			searchPlaceholder={searchPlaceholder}
			isPaginated={false}
			enabled={!disabled}
		/>
	);
}

export default StaticSelectFilter;
